// Copy for SiteFooter.tsx, kept in its own dictionary rather than the giant strings.ts/
// additionalLocales.ts — same precedent as leakStrings.ts/environmentCheckStrings.ts. Locales
// without a full translation fall back to English via getFooterStrings.
export interface FooterStrings {
  tagline: string;
  about: string;
  pricing: string;
  editorialPolicy: string;
  contact: string;
  privacy: string;
  terms: string;
  refundPolicy: string;
  disclaimer: string;
  allChecks: string;
  claudeAccessChecker: string;
  openSource: string;
  openSourceCli: string;
  openSourceSdk: string;
  copyright: (year: number) => string;
}

const en: FooterStrings = {
  tagline: "Network Risk, IP Reputation & Privacy Tools",
  about: "About",
  pricing: "Pricing",
  editorialPolicy: "Editorial Policy",
  contact: "Contact",
  privacy: "Privacy",
  terms: "Terms",
  refundPolicy: "Refund Policy",
  disclaimer: "Disclaimer",
  allChecks: "All Checks",
  claudeAccessChecker: "Claude Access Checker",
  openSource: "Open Source",
  openSourceCli: "CLI",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const zhCn: FooterStrings = {
  tagline: "网络风险、IP 信誉与隐私工具",
  about: "关于我们",
  pricing: "价格",
  editorialPolicy: "编辑政策",
  contact: "联系我们",
  privacy: "隐私政策",
  terms: "使用条款",
  refundPolicy: "退款政策",
  disclaimer: "免责声明",
  allChecks: "全部检测工具",
  claudeAccessChecker: "Claude 访问检测",
  openSource: "开源项目",
  openSourceCli: "CLI 命令行工具",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const zhTw: FooterStrings = {
  tagline: "網路風險、IP 信譽與隱私工具",
  about: "關於我們",
  pricing: "價格",
  editorialPolicy: "編輯政策",
  contact: "聯絡我們",
  privacy: "隱私政策",
  terms: "使用條款",
  refundPolicy: "退款政策",
  disclaimer: "免責聲明",
  allChecks: "所有檢測工具",
  claudeAccessChecker: "Claude 存取檢測",
  openSource: "開源專案",
  openSourceCli: "CLI 命令列工具",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const ja: FooterStrings = {
  tagline: "ネットワークリスク・IPレピュテーション・プライバシーツール",
  about: "会社概要",
  pricing: "料金",
  editorialPolicy: "編集ポリシー",
  contact: "お問い合わせ",
  privacy: "プライバシーポリシー",
  terms: "利用規約",
  refundPolicy: "返金ポリシー",
  disclaimer: "免責事項",
  allChecks: "すべてのチェック",
  claudeAccessChecker: "Claudeアクセスチェッカー",
  openSource: "オープンソース",
  openSourceCli: "CLI",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const ko: FooterStrings = {
  tagline: "네트워크 위험, IP 평판 및 개인정보 보호 도구",
  about: "소개",
  pricing: "요금제",
  editorialPolicy: "편집 정책",
  contact: "문의하기",
  privacy: "개인정보 처리방침",
  terms: "이용약관",
  refundPolicy: "환불 정책",
  disclaimer: "면책 조항",
  allChecks: "모든 검사",
  claudeAccessChecker: "Claude 접근 검사기",
  openSource: "오픈소스",
  openSourceCli: "CLI",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const es: FooterStrings = {
  tagline: "Riesgo de red, reputación de IP y herramientas de privacidad",
  about: "Acerca de",
  pricing: "Precios",
  editorialPolicy: "Política editorial",
  contact: "Contacto",
  privacy: "Privacidad",
  terms: "Términos",
  refundPolicy: "Política de reembolso",
  disclaimer: "Aviso legal",
  allChecks: "Todas las comprobaciones",
  claudeAccessChecker: "Verificador de acceso a Claude",
  openSource: "Código abierto",
  openSourceCli: "CLI",
  openSourceSdk: "SDK de JavaScript",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const de: FooterStrings = {
  tagline: "Netzwerkrisiko, IP-Reputation und Datenschutz-Tools",
  about: "Über uns",
  pricing: "Preise",
  editorialPolicy: "Redaktionelle Richtlinien",
  contact: "Kontakt",
  privacy: "Datenschutz",
  terms: "Nutzungsbedingungen",
  refundPolicy: "Rückerstattungsrichtlinie",
  disclaimer: "Haftungsausschluss",
  allChecks: "Alle Prüfungen",
  claudeAccessChecker: "Claude-Zugriffsprüfung",
  openSource: "Open Source",
  openSourceCli: "CLI",
  openSourceSdk: "JavaScript-SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const fr: FooterStrings = {
  tagline: "Risque réseau, réputation IP et outils de confidentialité",
  about: "À propos",
  pricing: "Tarifs",
  editorialPolicy: "Politique éditoriale",
  contact: "Contact",
  privacy: "Confidentialité",
  terms: "Conditions d'utilisation",
  refundPolicy: "Politique de remboursement",
  disclaimer: "Avertissement",
  allChecks: "Tous les contrôles",
  claudeAccessChecker: "Vérificateur d'accès Claude",
  openSource: "Open source",
  openSourceCli: "CLI",
  openSourceSdk: "SDK JavaScript",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const ptBr: FooterStrings = {
  tagline: "Risco de rede, reputação de IP e ferramentas de privacidade",
  about: "Sobre",
  pricing: "Preços",
  editorialPolicy: "Política editorial",
  contact: "Contato",
  privacy: "Privacidade",
  terms: "Termos de uso",
  refundPolicy: "Política de reembolso",
  disclaimer: "Aviso legal",
  allChecks: "Todas as verificações",
  claudeAccessChecker: "Verificador de acesso Claude",
  openSource: "Código aberto",
  openSourceCli: "CLI",
  openSourceSdk: "SDK JavaScript",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const ru: FooterStrings = {
  tagline: "Сетевые риски, репутация IP и инструменты конфиденциальности",
  about: "О нас",
  pricing: "Тарифы",
  editorialPolicy: "Редакционная политика",
  contact: "Контакты",
  privacy: "Конфиденциальность",
  terms: "Условия использования",
  refundPolicy: "Политика возврата",
  disclaimer: "Отказ от ответственности",
  allChecks: "Все проверки",
  claudeAccessChecker: "Проверка доступа Claude",
  openSource: "Открытый исходный код",
  openSourceCli: "CLI",
  openSourceSdk: "JavaScript SDK",
  copyright: (year) => `© ${year} NetRiskScan`,
};

const dictionaries: Record<string, FooterStrings> = {
  en,
  "zh-cn": zhCn,
  "zh-tw": zhTw,
  ja,
  ko,
  es,
  de,
  fr,
  "pt-br": ptBr,
  ru,
};

export function getFooterStrings(languageCode: string): FooterStrings {
  return dictionaries[languageCode.toLowerCase()] ?? en;
}
